import { raiseErrorToast } from '@fiverr-private/identification_core';
import { appTranslate } from '../../../i18n';

export const raiseGeneralErrorToast = () => raiseErrorToast(appTranslate<string>('errors.general'));
